import { Icon, Tooltip } from "@mui/material";
import { componentsMap } from "../ComponentsMap";
import DashboardEnvContext from "../DashboardEnvContext";
import DashboardPageContext from "../DashboardPageContext";
import ErrorBoundary from "../ErrorBoundary";
import ExecutionTypeContext from "../ExecutionTypeContext";
import { evalJs, evalText } from "../js-utils";
import { CDashboardModuleTabComponent, JSEvalContext, PageContext } from "../types";
import { useCallback, useContext, useMemo, useState } from "react";
import DataGridRowContext from "./DataGridRowContext";

interface CDashboardModuleTabComponentProps {
	component: CDashboardModuleTabComponent;
}

const DashboardComponent: React.FC<CDashboardModuleTabComponentProps> = ({ component }) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const dashboard = useContext(DashboardEnvContext);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const pageContext = useContext(DashboardPageContext);
	const row = useContext(DataGridRowContext);
	const [buildingError, setBuildingError] = useState<string | null>(null);
	const exeMode = useContext(ExecutionTypeContext);
	const Component = useMemo(() => componentsMap[component.type].component, [component]);
	const displayed = useMemo(() => {
		if (!component.properties["displayCondition"]) return true;
		try {
			if (eval(component.properties["displayCondition"])) return true;
			else return false;
		} catch (error) {
			console.error(error);
			return false;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, pageContext.context]);
	const evaluteText = (text: string, breakOnFail?: boolean, overridenContext?: PageContext): string | null => {
		return evalText(
			{
				pageContext: overridenContext ? overridenContext : pageContext,
				row,
				dashboard,
				exeMode,
				logError: (error) => {
					if (!breakOnFail || breakOnFail === true) setBuildingError(error);
				},
			} as JSEvalContext,
			text,
		);
	};
	const evaluteScript = (script: string, breakOnFail?: boolean, overridenContext?: PageContext): unknown | null => {
		return evalJs(
			{
				pageContext: overridenContext ? overridenContext : pageContext,
				row,
				dashboard,
				exeMode,
				logError: (error) => {
					if (!breakOnFail || breakOnFail === true) setBuildingError(error);
				},
			} as JSEvalContext,
			script,
		);
	};
	return (
		<>
			{displayed && buildingError === null && (
				//@ts-ignore
				<Component component={component} evalJsText={evaluteText} evaluteScript={evaluteScript} />
			)}
			{buildingError !== null && (
				<Tooltip title={buildingError} componentsProps={{ tooltip: { sx: { backgroundColor: "red" } } }}>
					<Icon sx={{ color: "red" }}>error</Icon>
				</Tooltip>
			)}
		</>
	);
};

export default DashboardComponent;
